import React, { memo } from 'react';
import { IconLoader } from 'common/IconLoader';

const MaintenancePanelHeader = (props) => {
  return (
    <div id="maintenanceBarTitleLabel" className="maintenanceBarTitleLabel">
      <img
        alt=""
        src={
          props.targetDeviceType === 'echo' || props.targetDeviceType === 'subscriber'
            ? IconLoader.icon_echo
            : props.source === 'overview'
            ? IconLoader.icon_pivot_header
            : props.targetDeviceType === 'service'
            ? IconLoader.icon_service
            : IconLoader.icon_donor
        }
      />
      Maintenance
    </div>
  );
};

export default memo(MaintenancePanelHeader);
